export default {"src":"/_next/static/media/ic_check_black.205c94ff.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};